import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LoadingController, ToastController } from "ionic-angular";
import { EXTERNAL_FACE_TO_FACE_CONFIG } from "mocks/sections/mock-external-face-to-face";
// import {SUPERVISORY_CONFIG} from "../../mocks/sections/mock-supervisory-config";
// import {SUMMARY_CONFIG} from "../../mocks/sections/mock-summary-config";
// import {TEST_CONFIG} from "../../mocks/mock-test-config";
// import {VITALS_CONFIG} from "../../mocks/sections/mock-vitals-config";
// import {VOLUNTEER_CONFIG} from "../../mocks/sections/mock-volunteer-config";
// import {PREFERENCES_CONFIG} from "../../mocks/sections/mock-preferences-config";
// import { SPIRITUAL_CARE_CONFIG} from "../../mocks/sections/mock-spiritual-care-config";
import { Observable } from "rxjs/Observable";
import { BILLING_CONFIG } from "../../mocks/sections/mock-billing-config";
import Section from "../../models/assessment/section";
import { ConfigurationService } from "../configuration/configuration.service";

// import {BILLING_CONFIG} from "../../mocks/sections/mock-billing-config";

@Injectable()
export class ContentConfigService {
  templateUrl: string;

  constructor(
    public httpClient: HttpClient,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    private config: ConfigurationService
  ) {
    this.templateUrl = config.getConfig().apiUrl;

    // console.log( "Set data URL in content config data: ", this.templateUrl );
  }

  loadTemplate(assessmentId: string, sectionId: string): Observable<any> {
    let url =
      this.templateUrl + "/visits/" + assessmentId + "/template/" + sectionId;
    // console.log( "Attempting to load template: ", url );
    return new Observable((observer) => {
      // TODO: Show loading spinner
      this.httpClient.get(url).subscribe(
        (data) => {
          // console.log( "Template data:", data );

          let template = data["tmplJson"]
            ? JSON.parse(data["tmplJson"]["value"])
            : null;
          // console.log( "Parsed out template:", template );
          if (template) {
            for (let card of template.cards) {
              if (card.inputs) {
                for (let id of Object.keys(card.inputs)) {
                  card.inputs[id].id = id;
                }
              }
            }

            observer.next(template);
          } else {
            observer.error();
          }
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error();
        }
      );
    });
  }

  loadSectionConfig(sectionId: string): Section {
    // console.log( "Section config requested:", sectionId );
    let config;

    // TODO: Use this space to temporarily fill in new templates under development
    switch (sectionId) {
      case "test": {
        config = BILLING_CONFIG;
        break;
      }
      case "externalFaceToFace": {
        config = EXTERNAL_FACE_TO_FACE_CONFIG;
        break;
      }
      default: {
        return undefined;
      }
    }
    for (let card of config.cards) {
      if (card.inputs) {
        for (let id of Object.keys(card.inputs)) {
          card.inputs[id].id = id;
        }
      }
    }
    return config;
  }
}



// WEBPACK FOOTER //
// ./src/providers/content-config/content-config-service.ts